<template>
  <v-layout>
    <div v-if="debug">
      <hr />
      {{ id == "" }} -{{ id }}-
    </div>
    <v-flex>
      <v-layout align-baseline>
        <v-flex>
          <h1 class="headline">{{ editLabel }}</h1>
        </v-flex>
        <v-flex>
          <v-layout justify-end pa-3>
            <one-page-view-switch
              setting-name="agentOnePageView"
              v-model="onePage"
            />
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout v-if="onePage">
        <v-expansion-panels v-model="panels" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <h5 class="headline">Details</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <agent-editor-details
                :agent="updatedAgent"
                @onSave="saveAgent"
                @onChange="onChangeAgent"
              ></agent-editor-details>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel
            :disabled="disabled"
            v-if="
              $store.getters.hasAccessTo(
                'administration_panel:user_access_control'
              )
            "
          >
            <v-expansion-panel-header>
              <h5 class="headline">Access</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <access-settings-editor
                v-model="updatedAgent.accessSettings"
              ></access-settings-editor>

              <v-layout justify-center>
                <save-btn v-if="showSave" @click="saveAgent"></save-btn>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :disabled="disabled">
            <v-expansion-panel-header>
              <h5 class="headline">Finances</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <agent-editor-finances
                :financeSettings="updatedAgent.financeSettings"
                @changeFinanceSettings="onChangeFinanceSettings($event)"
              ></agent-editor-finances>
              <v-layout justify-center>
                <save-btn v-if="showSave" @click="saveAgent"></save-btn>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :disabled="disabled">
            <v-expansion-panel-header>
              <h5 class="headline">Payment Terms</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <payment-terms
                v-model="updatedAgent.paymentTerms"
              ></payment-terms>
              <v-layout justify-center>
                <save-btn v-if="showSave" @click="saveAgent"></save-btn>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :disabled="disabled">
            <v-expansion-panel-header>
              <h5 class="headline">Staff</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <agent-editor-staff :agent="updatedAgent"></agent-editor-staff>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel :disabled="disabled">
            <v-expansion-panel-header>
              <h5 class="headline">Custom Fields</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <custom-fields-form
                :show-title="false"
                :hide-save="!showSave"
                v-model="updatedAgent.customFields"
                @onSave="saveAgent"
              ></custom-fields-form>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <h5 class="headline">Itineraries</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <itinerary-list
                :cached-filters="false"
                :custom-filters="itinerariesFilter"
                :show-title="false"
                ref-name="agentItineraryList"
              ></itinerary-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel
            v-if="this.$store.getters.hasAccessTo('plugins:task_tracker')"
          >
            <v-expansion-panel-header>
              <h5 class="headline">Tasks</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <task-tracker-list :agent="updatedAgent"></task-tracker-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <h5 class="headline">Emails</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <emails-list :agent-id="id" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-layout>
      <v-layout v-else>
        <v-tabs
          class="gradient-bg elevation-2"
          background-color="transparent"
          centered
          dark
        >
          <v-tab key="details" ripple>Details</v-tab>
          <v-tab
            key="access"
            ripple
            :disabled="disabled"
            v-if="
              $store.getters.hasAccessTo(
                'administration_panel:user_access_control'
              )
            "
            >Access</v-tab
          >
          <v-tab key="settings" ripple :disabled="disabled">Settings</v-tab>
          <v-tab key="finance-settings" ripple :disabled="disabled"
            >Finances</v-tab
          >
          <v-tab key="payment-terms" ripple :disabled="disabled"
            >Payment Terms</v-tab
          >
          <v-tab key="staff" ripple :disabled="disabled">Staff</v-tab>
          <v-tab-item key="details">
            <agent-editor-details
              :agent="updatedAgent"
              @onSave="saveAgent"
              @onChange="onChangeAgent"
            ></agent-editor-details>
          </v-tab-item>
          <v-tab-item
            key="access"
            v-if="
              $store.getters.hasAccessTo(
                'administration_panel:user_access_control'
              )
            "
          >
            <v-container>
              <v-card class="pa-3">
                <access-settings-editor
                  v-model="updatedAgent.accessSettings"
                ></access-settings-editor>
              </v-card>

              <v-layout justify-center pt-3>
                <save-btn v-if="showSave" @click="saveAgent"></save-btn>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item key="settings">
            <v-container>
              <v-card class="pa-3">
                <agent-editor-configuration
                  v-model="updatedAgent.configSettings"
                ></agent-editor-configuration>
              </v-card>
              <v-layout justify-center pt-3>
                <save-btn v-if="showSave" @click="saveAgent"></save-btn>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item key="finance-settings">
            <v-container>
              <v-card class="pa-3">
                <agent-editor-finances
                  :finance-settings="updatedAgent.financeSettings"
                  @changeFinanceSettings="onChangeFinanceSettings($event)"
                ></agent-editor-finances>
              </v-card>
              <v-layout justify-center pt-3>
                <save-btn v-if="showSave" @click="saveAgent"></save-btn>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item key="payment-terms">
            <v-container>
              <v-card class="pa-3">
                <payment-terms
                  v-model="updatedAgent.paymentTerms"
                ></payment-terms>
              </v-card>
              <v-layout justify-center pt-3>
                <save-btn v-if="showSave" @click="saveAgent"></save-btn>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item key="staff">
            <v-container>
              <v-card class="pa-3">
                <agent-editor-staff :agent="updatedAgent"></agent-editor-staff>
              </v-card>
            </v-container>
          </v-tab-item>

          <v-tab key="customFields" ripple>Custom Fields</v-tab>
          <v-tab-item key="customFields">
            <v-card flat>
              <v-card-text>
                <custom-fields-form
                  v-model="updatedAgent.customFields"
                  @onSave="saveAgent"
                  :hide-save="!showSave"
                ></custom-fields-form>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab key="itineraries" ripple>Itineraries</v-tab>
          <v-tab-item key="itineraries">
            <v-card flat>
              <v-card-text>
                <itinerary-list
                  :cached-filters="false"
                  :custom-filters="itinerariesFilter"
                  :show-title="false"
                  ref-name="agentItineraryList"
                ></itinerary-list>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab
            key="tasks"
            ripple
            v-if="this.$store.getters.hasAccessTo('plugins:task_tracker')"
            >Tasks</v-tab
          >
          <v-tab-item key="tasks">
            <v-card flat>
              <v-card-text>
                <task-tracker-list :agent="updatedAgent"></task-tracker-list>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab key="email" ripple>Emails</v-tab>
          <v-tab-item key="emails">
            <emails-list :agent-id="id" />
          </v-tab-item>
        </v-tabs>
      </v-layout>
      <v-layout>
        <back-to-list-btn
          route="/admin/agents"
          v-if="!isModal"
        ></back-to-list-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  AGENT_RECORD_QUERY,
  AGENT_UPDATE_MUTATION,
  AGENT_CREATE_MUTATION,
  ALL_AGENTS_WITH_CURRENCY,
} from "../../../constants/graphql";
import AgentEditorDetails from "./AgentEditorDetails";
import AgentEditorConfiguration from "./AgentEditorConfiguration";
import AgentEditorFinances from "./AgentEditorFinances";
import AgentEditorStaff from "./AgentEditorStaff";
import { SaveGqlObjectMixin } from "../../../mixins/SaveGqlObjectMixin.js";
import { UpdateAgentInputMixin } from "./mixins/UpdateAgentInputMixin.js";
import PropagateAccessTaskMixin from "../../../mixins/PropagateAccessTaskMixin";
import CustomFieldsForm from "../shared/CustomFieldsForm";
import AccessSettingsEditor from "./AccessSettingsEditor";
import BackToListBtn from "../shared/BackToListBtn";
import OnePageViewSwitch from "../shared/OnePageViewSwitch";
import PaymentTerms from "../shared/payment-terms/PaymentTerms";
import { removeGQLTypename } from "../../../helpers/index";
import UnsavedChangesGuard from "../../../mixins/UnsavedChangesGuard";
import SaveBtn from "../shared/SaveButton";
import ItineraryList from "../itineraries/ItineraryList";
import TaskTrackerList from "../plugins/task-tracker/TaskTrackerList";
import EmailsList from "../shared/EmailsList";
export default {
  name: "AgentEditor",
  props: {
    agentId: {
      type: String,
      default: () => "",
    },
    isModal: {
      type: Boolean,
      dafault: () => false,
    },
  },

  mixins: [SaveGqlObjectMixin, UnsavedChangesGuard, PropagateAccessTaskMixin],
  components: {
    AccessSettingsEditor,
    AgentEditorDetails,
    AgentEditorConfiguration,
    AgentEditorFinances,
    AgentEditorStaff,
    CustomFieldsForm,
    BackToListBtn,
    OnePageViewSwitch,
    PaymentTerms,
    SaveBtn,
    ItineraryList,
    TaskTrackerList,
    EmailsList,
  },
  data() {
    return {
      debug: false,
      onePage: false,
      panels: [0],
      id:
        this.agentId != ""
          ? this.agentId
          : this.$route.params.id
          ? this.$route.params.id
          : "",
      skipLoad: true,
      updatedAgent: {
        languageId: this.$store.getters.userConfig.agentLanguageId,
      },
      loading: false,
      save: false,
    };
  },

  computed: {
    showSave() {
      return true;
      return (
        !this.$store.getters.hasAccessTo("agents:view_only") &&
        this.$store.getters.hasAccessTo("agents:edit_agent")
      );
    },
    itinerariesFilter() {
      return this.agent
        ? {
            gtAgentId_eq: this.agent.id,
          }
        : {};
    },
    editLabel() {
      return this.updatedAgent.name ? `${this.updatedAgent.name}` : "New Agent";
    },
    disabled() {
      return this.updatedAgent.name ? false : true;
    },
    agentInput() {
      const {
        accessSettings,
        configSettings,
        financeSettings,
        customFields,
        __typename,
        ...details
      } = this.updatedAgent;
      const accessSettingsInput = accessSettings
        ? accessSettings.map((item) => ({
            groupName: item.groupName,
            settingName: item.settingName,
            settingValue: item.settingValue,
          }))
        : {};
      const configSettingsInput = { ...configSettings };
      delete configSettingsInput.__typename;
      const financeSettingsInput = { ...financeSettings };
      delete financeSettingsInput.__typename;
      const input = {
        ...details,
        configSettings: configSettingsInput,
        accessSettings: accessSettingsInput,
        financeSettings: financeSettingsInput,
        customFields,
      };
      return input;
    },
  },

  watch: {
    agentId(newAgentId) {
      this.id = newAgentId;
      this.skipLoad = false;
    },
  },

  methods: {
    onChangeConfigSettings(configSettings) {
      this.updatedAgent.configSettings = configSettings;
    },
    onChangeFinanceSettings(financeSettings) {
      this.updatedAgent.financeSettings = financeSettings;
    },
    onChangeAgent(agent) {
      let fs = this.updatedAgent.financeSettings;
      //let cs = this.updatedAgent.configSettings;
      this.updatedAgent = { ...agent };
      this.updatedAgent.financeSettings = fs;
      //this.updatedAgent.configSettings = cs;
    },
    onChangeCustomFields(data) {
      this.updatedAgent.customFields = data;
    },
    saveAgent() {
      this.loading = true;
      this.saveGqlObject(
        this.agentInput,
        AGENT_CREATE_MUTATION,
        AGENT_UPDATE_MUTATION
      );
    },
    saveGqlObjectHandler(result) {
      this.loading = false;
      if (result.data.hasOwnProperty("createAgent")) {
        this.$apollo.queries.agentsWithCurrencies.refetch(); //http://tracker.globetrack.ie/issues/5084
        this.id = result.data.createAgent.id;
        this.$router.push("/agent/" + this.id + "/edit");
        this.$store.dispatch("showAppSnackbar", { msg: "Agent Created." });
      } else {
        this.$apollo.queries.agent.refetch();
        this.$store.dispatch("showAppSnackbar", { msg: "Agent Updated." });
      }
      this.storeInitState();
    },
  },

  apollo: {
    agentsWithCurrencies: {
      //http://tracker.globetrack.ie/issues/5084
      query: ALL_AGENTS_WITH_CURRENCY,
      update: (data) => data.agents,
    },
    agent: {
      query: AGENT_RECORD_QUERY,
      variables() {
        return {
          id: this.id,
        };
      },
      skip() {
        return this.id == "" || this.skipLoad;
      },
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {
        if (data.agent) {
          const { customFields, paymentTerms, ...agent } = data.agent;
          this.updatedAgent = {
            ...agent,
            customFields: customFields.edges.map((i) => ({
              name: i.node.name,
              content: i.node.content,
              typeId: i.node.typeId,
            })),
            paymentTerms: paymentTerms.edges.map(removeGQLTypename),
          };
        }
        this.skipLoad = true;
        this.storeInitState();
      },
    },
  },
  mounted() {
    this.skipLoad = false;
  },
};
</script>

<style scoped>
.gradient-bg {
  background: linear-gradient(to right top, #4527a0, #9575cd);
}
</style>



// WEBPACK FOOTER //
// src/components/gt/agents/AgentEditor.vue